import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { IWhatsAppConfigRepository } from "./IWhatsAppConfigRepository";
import { ResponseModel } from "src/app/models/SharedModels/response.model";
import { WhatsAppConfig } from "src/app/models/whatsappConfig/whatsapp-config.model";

@Injectable({
    providedIn: "root"
})
export class WhatsAppConfigRepository extends GenericRepository<WhatsAppConfig> implements IWhatsAppConfigRepository {
    url: string = environment.urlAddress;

    constructor(protected _http: HttpClient) {
        super(_http, 'api/WhatsAppConfig', environment.urlAddress);
    }

    GetRec(): Observable<any> {
        return this._http
            .get(this.url + 'api/WhatsAppConfig/Select', this.httpOptions)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    SaveRec(config: WhatsAppConfig): Observable<ResponseModel> {
        return this.PostData('/SaveRec', config).pipe(map(this.extractData), catchError(this.handleError));
    }
}